import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { parse, format } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';

function ParticipanteItem({ row, onSelect, isSelected }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const participante = row.original;

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const handleCheckboxChange = () => onSelect(participante.id);

    const { key, ...rowProps } = row.getRowProps();

    return (
        <tr {...rowProps} className="bmember-b bmember-stroke border-b border-gray-200">
            <td className="text-left xl:p-4 text-sm font-medium">
                <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={handleCheckboxChange}
                />
            </td>
            <td className="p-2 2xl:p-4 xl:pl-0 text-left font-medium uppercase text-sm">{participante.nome}</td>
            <td className="p-2 2xl:p-4 xl:pl-0 text-left font-medium text-sm">{participante.ativo == 1 ? 'Ativo' : 'Inativo'}</td>
            <td className="p-2 2xl:p-4 xl:pl-0 text-left font-medium text-sm">{participante.cpf}</td>
            <td className="p-2 2xl:p-4 xl:pl-0 text-left font-medium text-sm">{participante.rg}</td>
            <td className="p-2 2xl:p-4 xl:pl-0 text-left font-medium text-sm">{participante.fone}</td>
            <td className="p-2 2xl:p-4 xl:pl-0 text-left font-medium text-sm">{participante.razao}<br/>({participante.cnpj})</td>
            <td className="p-2 pr-0 text-left 1xl:p-4 xl:pr-0 text-xs 1xl:text-sm">
                <div className="flex items-center gap-0 ml-3">
                    <Link to={`/manager/participantes/editar/${participante.participante_id}`} className="bg-primary w-8 h-8 rounded-full flex items-center justify-center duration-200 ease-in-out hover:bg-opacity-80">
                        <FontAwesomeIcon icon={faEdit} className="text-white ml-[1px] mb-[1px]" />
                    </Link>
                </div>
            </td>
        </tr>
    );
}

export default ParticipanteItem;
